import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const adminTrackmanParametersV2QueryKey = ['adminTrackmanParametersV2'];

export const useTrackmanParametersV2 = () => {
  const service = useServices().trackmanParametersV2Service;
  return useQuery({
    queryKey: adminTrackmanParametersV2QueryKey,
    queryFn: service.getParameters,
    refetchOnWindowFocus: false,
  });
};
